import React from 'react'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowRight, faHeart } from '@fortawesome/free-solid-svg-icons';
import "./blog.css"
import { Link } from 'react-router-dom';
import { HiMiniArrowLongRight } from "react-icons/hi2";

const Blogblog = ({data}) => {
  return (
    <>
    {data.map((post, index) => (
      <div key={post.id} className={`py-[50px] max-sm:pt-6 ${index % 2 === 0 ? 'flex-row' : 'flex-col-reverse'}`}>
        <div className='lg:mx-[174px] max-lg:mx-[20px] md:mx-[20px] px-[15px]'>
          <div className="">
            <div className={`holder flex lg:flex-row md:flex-row max-sm:flex-col justify-center`}>
              <div className={`w-[100%] inline-block mr-[40px] max-sm:w-[100%] ${index % 2 === 0 ? 'order-last' : ''}`}>
                <img className='w-full max-w-full h-auto' src={post.img} alt="Fab Gold" />
              </div>
              <div id='text-wrap' className={`lg:pl-[56px] lg:pr-[70px] lg:py-[77px] max-sm:py-5 ${index % 2 === 0 ? 'order-first' : ''}`}>
                <h2 id='blog-heading' className="lg:mb-[54px] max-sm:mb-[17px] text-[24px] leading-[26px] uppercase relative pb-3 tracking-[2px] font-bold text-tertary2">{post.head}</h2>
                <p className='mb-[51px] md:mb-[25px] text-[17px] w-[82%] text-black md:pt-[12px]'>{post.para} </p>
                <Link to={"/blogdetail/"+post.id} className="font-bold leading-5 text-[18px] text-tertary2 21 flex group">
                  Continue    <HiMiniArrowLongRight className="text-2xl ml-1 transition-transform duration-300 transform group-hover:translate-x-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </>
  )
}

export default Blogblog